import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { NavMenuDivider, NavMenuItem } from 'components/NavMenu';
import { WebAppInstallPromptContext } from '../../webAppInstallPrompt/context';
function AddToHomeScreen() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useContext = useContext(WebAppInstallPromptContext),
    capturedPrompt = _useContext.capturedPrompt,
    promptUser = _useContext.promptUser;
  if (!capturedPrompt) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(NavMenuDivider, null), /*#__PURE__*/React.createElement(NavMenuItem, {
    id: "a2hs_button",
    onClick: promptUser
  }, t('actions_add_to_homescreen')));
}
export default AddToHomeScreen;